import { ref, watch } from 'vue'
import { useLoadImportPassportTemplate } from './api.ts'
import useValidate from '@/shared/lib/validate'
import { DateTime } from 'ts-luxon'

export const useModel = () => {
  const listTemplates = ref<{ id: number; name: string }[]>([])
  const { fileTypes, required } = useValidate()
  const getDefaultImportDate = () => {
    return DateTime.local().toFormat('yyyy-LL-dd')
  }

  const data = ref<{ import_template_id: null | number; import_file: null | File; ver_date: string }>({
    import_template_id: null,
    import_file: null,
    ver_date: getDefaultImportDate(),
  })

  /* Правила валидации */
  const rules = {
    import_template_id: [(value: any) => required(value)],
    import_file: [
      (value: any) =>
        fileTypes(
          [value],
          [
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          ],
        ),
    ],
    ver_date: [(value: any) => required(value)],
  }

  /**
   * Функция загрузки шаблонов
   */
  const loadTemplates = () => {
    const result = useLoadImportPassportTemplate()

    watch(result.data, () => {
      if (result.data.value) {
        listTemplates.value = result.data.value.data
      }
    })

    return result
  }

  /**
   * Функция очистки данных
   */
  const clearData = () => {
    data.value = {
      import_file: null,
      import_template_id: null,
      ver_date: getDefaultImportDate(),
    }
  }

  return {
    data,
    listTemplates,
    rules,

    loadTemplates,
    clearData,
  }
}
